import React, { Component } from 'react'
import { observer } from 'mobx-react'
import CompanyTasksTable from './companytaskstable'

@observer(['globals', 'tasks'])
export default class Pending extends Component {

  constructor(props) {
    super(props)
  }

  reload(callback) {
    this.props.tasks.loadAllPendingTasks(() => {
      if (callback != null) {
        callback()
      }
    })
  }

  render() {
    return (
      <div>
        <CompanyTasksTable data={ this.props.tasks.pending } reload={ this.reload.bind(this) } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/tasks/pending.js